import { useInfiniteQuery } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IPendencyDetailsPayload } from '../../../types';

/**
 * This is to track search package api state.
 */
export const PENDENCY_DETAILS_QUERY_QUERY_KEY = 'pendency-details-query-key';

/**
 * This hook fetches the inbound Pod Details from mock APi.
 */
export const usePendencyDetailsQuery = (payload: IPendencyDetailsPayload) => {
  const { filterKey, inflowFilterType, limit, page, isToday, podType } =
    payload;

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      PENDENCY_DETAILS_QUERY_QUERY_KEY,
      page,
      limit,
      filterKey,
      inflowFilterType,
      isToday,
      podType,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    retry: false,
    queryFn: ({ pageParam = 1 }) =>
      INV_MGMT_SERVICE_API.getPendencyDetails({ ...payload, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * (limit || 20);

      return currentCount < lastPage.inventories.total ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
